import { getDeployment } from './getDeployment';

export const getUrl = () => {
  const deployment = getDeployment();
  const sub = deployment === 'preview' ? '.preview' : '';
  return `https://api${sub}.stage.bio`;
};
